module.exports = __webpack_public_path__ + "img/db_gift_right.43d37214.png";